/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { resetStoreAction } from 'state/commonActions';

type RoommateInvitationRequestState = Record<string, string | undefined>;

const initialState: RoommateInvitationRequestState = {};

const roommateInvitationSlice = createSlice({
  name: 'roommateInvitation',
  initialState,
  reducers: {
    startRoommateInvitationRequest: (
      state,
      action: PayloadAction<{ responseId: string; requestId: string }>,
    ) => {
      state[action.payload.responseId] = action.payload.requestId;
    },
    clearRoommateInvitationRequest: (state, action: PayloadAction<{ responseId: string }>) => {
      delete state[action.payload.responseId];
    },
    finishRoommateInvitationRequest: (
      state,
      action: PayloadAction<{ responseId: string; requestId: string }>,
    ) => {
      if (state[action.payload.responseId] === action.payload.requestId) {
        delete state[action.payload.responseId];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetStoreAction, () => initialState);
  },
});

export const {
  clearRoommateInvitationRequest,
  startRoommateInvitationRequest,
  finishRoommateInvitationRequest,
} = roommateInvitationSlice.actions;

export default roommateInvitationSlice.reducer;
